import { apiGet } from '../api'

export default {
  namespaced: true,
  state: {
    current: null,
  },
  mutations: {
    setCurrent: (state, { company }) => {
      state.current = company
    },
  },
  actions: {
    getCurrent: (
      { rootState, state, commit, dispatch },
      { reload = false } = {},
    ) => {
      if (!rootState.auth.token) {
        commit('setCurrent', { company: null })
        return Promise.resolve()
      }
      if (!reload && state.current) return Promise.resolve()
      return apiGet({ url: 'api/company/current/', rootState, dispatch })
        .then(({ res: company }) => commit('setCurrent', { company }))
    },
  },
}
